import {
  GenericComplianceDataRequest,
  GetRisksRequest,
  GetDashboardDataResponse,
  GetControlAssetsRequest,
  GetRisksResponse,
  GetControlResourcesResponse,
  GetControlIdentitiesResponse,
} from '@nirvana/shared/dtos/types/compliance-reports/gz-console';
import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ComplianceAppWebComponentSchema } from '../types';

export class ComplianceAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<ComplianceAppWebComponentSchema> {
    throw new Error('Not implemented');
  }

  async getControlResources(request: GetControlAssetsRequest): Promise<GetControlResourcesResponse> {
    throw new Error('Not implemented');
  }

  async getControlIdentities(request: GetControlAssetsRequest): Promise<GetControlIdentitiesResponse> {
    throw new Error('Not implemented');
  }
  async getMisconfigurations(request: GetRisksRequest): Promise<GetRisksResponse> {
    throw new Error('Not implemented');
  }

  async getUserBehaviorRisks(request: GetRisksRequest): Promise<GetRisksResponse> {
    throw new Error('Not implemented');
  }

  async generatePdf(request: GenericComplianceDataRequest): Promise<any> {
    throw new Error('Not implemented');
  }

  async generateXlsx(request: GenericComplianceDataRequest): Promise<any> {
    throw new Error('Not implemented');
  }

  async getDashboardData(request: GenericComplianceDataRequest): Promise<GetDashboardDataResponse> {
    throw new Error('Not implemented');
  }
}
